module.exports = __webpack_public_path__ + "static/media/gi.6ecace18.svg";